import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { generateGUID } from '../../utility';

@Component({
  selector: 'app-long-text-popover',
  templateUrl: './long-text-popover.component.html',
  styleUrls: ['./long-text-popover.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('150ms ease-in', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('150ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class LongTextPopoverComponent implements OnInit {
  @Input() text: string = '';
  @Input() title: string = '';
  @Input() maxChar: number = 0;
  @ViewChild('popover', { static: false, read: ElementRef }) popover: ElementRef | undefined;

  popupVisible = false;
  id: string = '';

  ngOnInit() {
    this.id = generateGUID();
  }

  show() {
    if (this.text.length <= this.maxChar) {
      return;
    }
    this.popupVisible = true;
  }

  hide() {
    this.popupVisible = false;
  }

  copy() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    navigator.clipboard
      .writeText(this.text)
      .then(() => document.body.removeChild(selBox))
      .catch(() => document.body.removeChild(selBox));
  }

  @HostListener('document:click', ['$event']) checkExternalClick($event: MouseEvent) {
    const targetElement = $event.target as HTMLElement;
    if (!this.popupVisible || (targetElement && targetElement.id && targetElement.id === this.id) || targetElement.id === this.id + '_e') {
      return;
    }
    if (!this.popover?.nativeElement.contains(targetElement)) {
      this.hide();
    }
  }
}
